"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesTasksPostAsyncSlice = void 0;
const name_1 = require("./name.js");
const _api_1 = require("../../../api/index.js");
const actions_1 = require("../_idMap/actions.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.coreInitiativesTasksPostAsyncSlice = (0, xuder_1.createPostAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.INITIATIVE_TASK_CREATED, (action) => ({
                initiativeId: action.data.initiativeId
            })),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request, response) => (0, actions_1.updateInitiativeReferences)([
                {
                    initiativeId: request.initiativeId,
                    tasks: {
                        toAdd: {
                            assignedTo: request.assignedTo,
                            completed: request.completed,
                            initiativeId: request.initiativeId,
                            initiativeTaskId: response.initiativeTaskId,
                            name: request.name,
                            orderIndex: request.orderIndex,
                            sonarObjects: []
                        }
                    }
                }
            ])
        ]
    },
    name: name_1.CoreInitiativesTasksName,
    receive: true,
    request: true,
    requestHandler: _api_1.postInitiativeTask
});
//# sourceMappingURL=post.js.map